import { JsonObject } from 'type-fest';

export const forms: JsonObject = {};
